import React, { Dispatch, useState } from 'react';

interface DailyTargetRatedPowerInputProps {
  value: number;
  index: number;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, index: number) => void;
  dailyTargetPowerElectricMap: Map<number, number>;
  setDailyTargetPowerElectricMap: Dispatch<Map<number, number>>;
  cellWidth: number;
}
export const DailyTargetRatedPowerInput = ({
  value,
  index,
  handleKeyDown,
  dailyTargetPowerElectricMap,
  setDailyTargetPowerElectricMap,
  cellWidth,
}: DailyTargetRatedPowerInputProps) => {
  const [currentValue, setCurrentValue] = useState(value);

  return (
    <input
      style={{ width: cellWidth - 16 * 2 }}
      className="border-box outline-none border-none text-center bg-transparent py-2 px-4 focus:outline focus:outline-green-200 focus:outline-offset-1"
      value={currentValue}
      onChange={(e) => setCurrentValue(+e.target.value)}
      onBlur={() => {
        const updatedMap = new Map(dailyTargetPowerElectricMap);
        return setDailyTargetPowerElectricMap(updatedMap.set(index, currentValue));
      }}
      onKeyDown={(e) => handleKeyDown(e, index)}
    />
  );
};
